import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="bg-[#0C0C0C] text-[#F3F2ED] relative overflow-hidden mt-24"
      data-testid="site-footer"
    >
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1530422190-4998587af64e')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          mixBlendMode: "screen",
        }}
      />
      <div className="grain-overlay" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 py-20">
        <h2 className="font-display text-[15vw] md:text-[10rem] leading-[0.85] tracking-tighter">
          LET&rsquo;S<br />
          <span className="text-[color:var(--primary)]">PRINT.</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-16 pt-10 border-t border-white/20">
          <div>
            <p className="label-mono text-white/60">Studio</p>
            <p className="font-body text-white mt-3 flex items-start gap-2">
              <MapPin size={16} className="mt-1 shrink-0" />
              American owned and operated
            </p>
            <a
              href="tel:+19099313557"
              className="font-body text-white mt-4 flex items-center gap-2 hover:text-[color:var(--primary)]"
              data-testid="footer-phone"
            >
              <Phone size={16} className="shrink-0" />
              (909) 931-3557
            </a>
            <Link
              to="/quote"
              className="label-mono text-white/80 hover:text-[color:var(--primary)] mt-4 inline-block"
              data-testid="footer-quote-link"
            >
              → Request a quote
            </Link>
          </div>
          <div>
            <p className="label-mono" style={{ color: "var(--dtf-yellow)" }}>Down To Film Apparel</p>
            <a
              href="mailto:Downtofilmapparel@gmail.com"
              className="font-body text-white mt-3 flex items-center gap-2 hover:text-[color:var(--dtf-yellow)] break-all transition-colors"
              data-testid="footer-email-dtf"
            >
              <Mail size={16} className="shrink-0" />
              <span>Downtofilmapparel@gmail.com</span>
            </a>
            <div className="mt-4 flex flex-wrap gap-2" data-testid="footer-socials-dtf">
              <a
                href="https://www.instagram.com/downtofilmapparel_/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Down To Film Apparel on Instagram"
                className="w-9 h-9 border border-white/30 inline-flex items-center justify-center hover:bg-[color:var(--dtf-yellow)] hover:text-black hover:border-[color:var(--dtf-yellow)] transition-colors"
                data-testid="footer-dtf-instagram"
              >
                <Instagram size={16} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61581234305948"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Down To Film Apparel on Facebook"
                className="w-9 h-9 border border-white/30 inline-flex items-center justify-center hover:bg-[color:var(--dtf-yellow)] hover:text-black hover:border-[color:var(--dtf-yellow)] transition-colors"
                data-testid="footer-dtf-facebook"
              >
                <Facebook size={16} />
              </a>
              <a
                href="https://www.tiktok.com/@the_sticky_chick"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Down To Film Apparel on TikTok"
                className="w-9 h-9 border border-white/30 inline-flex items-center justify-center hover:bg-[color:var(--dtf-yellow)] hover:text-black hover:border-[color:var(--dtf-yellow)] transition-colors"
                data-testid="footer-dtf-tiktok"
              >
                <i className="fa-brands fa-tiktok text-[15px]" aria-hidden="true" />
              </a>
              <a
                href="https://www.etsy.com/shop/DownToFilmApparel?etsrc=sdt"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Down To Film Apparel on Etsy"
                className="w-9 h-9 border border-white/30 inline-flex items-center justify-center hover:bg-[color:var(--dtf-yellow)] hover:text-black hover:border-[color:var(--dtf-yellow)] transition-colors"
                data-testid="footer-dtf-etsy"
              >
                <i className="fa-brands fa-etsy text-[15px]" aria-hidden="true" />
              </a>
              <a
                href="https://popl.co/profile/downtofilmapparel"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Down To Film Apparel digital card (Popl)"
                className="h-9 px-2.5 border border-white/30 inline-flex items-center justify-center label-mono text-[10px] hover:bg-[color:var(--dtf-yellow)] hover:text-black hover:border-[color:var(--dtf-yellow)] transition-colors"
                data-testid="footer-dtf-popl"
              >
                POPL
              </a>
            </div>
          </div>
          <div>
            <p className="label-mono" style={{ color: "var(--sc-pink)" }}>The Sticky Chick</p>
            <a
              href="mailto:Thestickychickcali@gmail.com"
              className="font-body text-white mt-3 flex items-center gap-2 hover:text-[color:var(--sc-pink)] break-all transition-colors"
              data-testid="footer-email-sc"
            >
              <Mail size={16} className="shrink-0" />
              <span>Thestickychickcali@gmail.com</span>
            </a>
            <div className="mt-4 flex flex-wrap gap-2" data-testid="footer-socials-sc">
              <a
                href="https://www.instagram.com/the_sticky_chick/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="The Sticky Chick on Instagram"
                className="w-9 h-9 border border-white/30 inline-flex items-center justify-center hover:bg-[color:var(--sc-pink)] hover:text-white hover:border-[color:var(--sc-pink)] transition-colors"
                data-testid="footer-sc-instagram"
              >
                <Instagram size={16} />
              </a>
              <a
                href="https://www.facebook.com/thestickychickcali"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="The Sticky Chick on Facebook"
                className="w-9 h-9 border border-white/30 inline-flex items-center justify-center hover:bg-[color:var(--sc-pink)] hover:text-white hover:border-[color:var(--sc-pink)] transition-colors"
                data-testid="footer-sc-facebook"
              >
                <Facebook size={16} />
              </a>
              <a
                href="https://www.tiktok.com/@the_sticky_chick"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="The Sticky Chick on TikTok"
                className="w-9 h-9 border border-white/30 inline-flex items-center justify-center hover:bg-[color:var(--sc-pink)] hover:text-white hover:border-[color:var(--sc-pink)] transition-colors"
                data-testid="footer-sc-tiktok"
              >
                <i className="fa-brands fa-tiktok text-[15px]" aria-hidden="true" />
              </a>
              <a
                href="https://www.etsy.com/shop/DownToFilmApparel?etsrc=sdt"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="The Sticky Chick on Etsy"
                className="w-9 h-9 border border-white/30 inline-flex items-center justify-center hover:bg-[color:var(--sc-pink)] hover:text-white hover:border-[color:var(--sc-pink)] transition-colors"
                data-testid="footer-sc-etsy"
              >
                <i className="fa-brands fa-etsy text-[15px]" aria-hidden="true" />
              </a>
              <a
                href="https://popl.co/profile/thestickychick"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="The Sticky Chick digital card (Popl)"
                className="h-9 px-2.5 border border-white/30 inline-flex items-center justify-center label-mono text-[10px] hover:bg-[color:var(--sc-pink)] hover:text-white hover:border-[color:var(--sc-pink)] transition-colors"
                data-testid="footer-sc-popl"
              >
                POPL
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/20 flex flex-wrap items-center justify-between gap-4">
          <p className="label-mono text-white/60">Same Etsy · TikTok shared across both brands</p>
          <p className="label-mono text-white/40 text-[10px]">
            Tap any icon above · new tab
          </p>
        </div>

        <div className="mt-12 pt-6 border-t border-white/20 flex flex-col md:flex-row justify-between gap-2 label-mono text-white/50 text-[11px]">
          <span>© {new Date().getFullYear()} Down To Film Apparel & The Sticky Chick</span>
          <span>Made in USA · DTF & Heat Press · Quality guaranteed</span>
        </div>
      </div>
    </footer>
  );
}
